import * as types from './annualHourTrackerActionType';

//Annual Hour Tracker - start
export const fetchAnnualHourTrackerRequest = (data) => ({
    type: types.FETCH_ANNUAL_HOUR_TRACKER_REQUEST,
    payload: data
});
export const fetchAnnualHourTrackerSuccess = (data) => ({
    type: types.FETCH_ANNUAL_HOUR_TRACKER_SUCCESS,
    payload: data
});
export const fetchAnnualHourTrackerFailure = (error) => ({
    type: types.FETCH_ANNUAL_HOUR_TRACKER_FAILURE,
    payload: error
});

export const fetchAnnualHourTrackerDropdownRequest = () => ({
    type: types.FETCH_ANNUAL_HOUR_TRACKER_DROPDOWN_REQUEST
});
export const fetchAnnualHourTrackerDropdownSuccess = (data) => ({
    type: types.FETCH_ANNUAL_HOUR_TRACKER_DROPDOWN_SUCCESS,
    payload: data
});
export const fetchAnnualHourTrackerDropdownFailure = (error) => ({
    type: types.FETCH_ANNUAL_HOUR_TRACKER_DROPDOWN_FAILURE,
    payload: error
});

export const fetchWorklistByRPCERequest = (rpceIds) => ({
    type: types.FETCH_ANNUAL_WORKLIST_BY_RPCE_REQUEST,
    payload: rpceIds
});
export const fetchWorklistByRPCESuccess = (data) => ({
    type: types.FETCH_ANNUAL_WORKLIST_BY_RPCE_SUCCESS,
    payload: data
});
export const fetchWorklistByRPCEFailure = (error) => ({
    type: types.FETCH_ANNUAL_WORKLIST_BY_RPCE_FAILURE,
    payload: error
});

export const fetchTaskByWorklistRequest = (worklistIds) => ({
    type: types.FETCH_TASK_BY_WORKLIST_REQUEST,
    payload: worklistIds
});
export const fetchTaskByWorklistSuccess = (data) => ({
    type: types.FETCH_TASK_BY_WORKLIST_SUCCESS,
    payload: data
});
export const fetchTaskByWorklistFailure = (error) => ({
    type: types.FETCH_TASK_BY_WORKLIST_FAILURE,
    payload: error
});

export const exportToCSVRequestAnnualHourTracker = (data) => ({
    type: types.EXPORT_TO_CSV_REQUEST_ANNUAL_HOUR_TRACKER,
    payload: data
});
export const exportToCSVSuccessAnnualHourTracker = (data) => ({
    type: types.EXPORT_TO_CSV_SUCCESS_ANNUAL_HOUR_TRACKER,
    payload: data
});
export const exportToCSVFailureAnnualHourTracker = (error) => ({
    type: types.EXPORT_TO_CSV_FAILURE_ANNUAL_HOUR_TRACKER,
    payload: error
});

export const refreshAnnualHourTrackerRequest = (data) => ({
    type: types.REFRESH_ANNUAL_HOUR_TRACKER_REQUEST,
    payload: data
});
export const refreshAnnualHourTrackerSuccess = (data) => ({
    type: types.REFRESH_ANNUAL_HOUR_TRACKER_SUCCESS,
    payload: data
});
export const refreshAnnualHourTrackerFailure = (error) => ({
    type: types.REFRESH_ANNUAL_HOUR_TRACKER_FAILURE,
    payload: error
});
//Annual Hour Tracker - end